import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "m-20 text-center no-rows" }


import { useStore } from 'vuex';
import Tab from '@shell/components/Tabbed/Tab.vue';
import { useI18n } from '@shell/composables/useI18n';

import DetailText from '@shell/components/DetailText.vue';

export interface Row {
  key: string;
  value: any;
  binary: boolean;
}

export interface Props {
  rows: Row[];
  weight?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    rows: {},
    weight: {}
  },
  setup(__props: any) {



const store = useStore();
const i18n = useI18n(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tab, {
    name: "data",
    "label-key": "secret.data",
    weight: _ctx.weight
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "mb-20"
        }, [
          _createVNode(DetailText, {
            value: row.value,
            label: row.key,
            binary: row.binary
          }, null, 8, ["value", "label", "binary"])
        ]))
      }), 128)),
      _cache[0] || (_cache[0] = _createTextVNode()),
      (!_ctx.rows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(i18n).t('sortableTable.noRows')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1,
    __: [0]
  }, 8, ["weight"]))
}
}

})